import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutIntro from './components/AboutIntro';
import ValuesSection from './components/ValuesSection';
import CertificationsSection from './components/CertificationsSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <AboutIntro />
        <ValuesSection />
        <CertificationsSection />
      </motion.div>
      <Footer />
    </div>
  );
};

export default AboutPage;